<template>
  <div :style="{'width': width, 'height': height}">
    <canvas ref="pie"></canvas>
  </div>
</template>
<script>
import Chart from 'chart.js';
import graphicsMixins from '@/mixins/graphics';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  props: {
    height: {
      type: String,
      default: '150px',
    },
    chart: {
      type: String,
      default: 'pie',
    },
    width: {
      type: String,
      default: '300px',
    },
    options: {
      type: Object,
      default: () => {},
    },
    legend: {
      type: Boolean,
      default: true,
    },
    graphicData: {
      type: Object,
      required: true,
    },
    randColour: {
      type: Boolean,
      default: false,
    },
    labelsInside: {
      type: Boolean,
      default: false,
    },
    labelsInsideColor: {
      type: String,
      default: '#FFF',
    },
    formatType: {
      type: String,
      default: 'percents',
    },
    tooltips: {
      type: Boolean,
      default: true,
    },
    responsive: {
      type: Boolean,
      default: true,
    },
    maintainAspectRatio: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    graphicsMixins,
  ],
  data() {
    return {
      graphics: {},
    };
  },
  mounted() {
    this.generateGraphic();
  },
  methods: {
    generateGraphic() {
      this.convertData();
      if (this.randColour) {
        this.createColors();
      }
      if (Object.keys(this.graphics).length > 0) {
        this.graphics.destroy();
      }
      let options = {
        legend: {
          display: this.legend,
        },
        tooltips: {
          enabled: this.tooltips,
        },
        responsive: this.responsive,
        maintainAspectRatio: this.maintainAspectRatio,
      };
      if (this.labelsInside) {
        options.plugins = {
          datalabels: {
            // eslint-disable-next-line
            formatter: (value, canvas) => {
              return this[`${this.formatType}Format`](value, canvas);
            },
            color: this.labelsInsideColor,
          },
        };
      }
      options = {
        ...options,
        ...this.options,
      };
      const canvas = this.$refs.pie.getContext('2d');
      this.graphics = new Chart(canvas, {
        type: this.chart,
        plugins: [ChartDataLabels],
        data: {
          labels: this.labels,
          datasets: [{
            backgroundColor: this.colors,
            data: this.numbers,
          }],
        },
        options,
      });
    },
  },
  watch: {
    graphicData: {
      deep: true,
      handler() {
        this.generateGraphic();
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/graphics/Chart.vue